export const getHomePath = (dash_key = null) => {
  if (dash_key) {
    return `/?dashboard=${dash_key}`;
  }
  return "/";
};
export const getLoginPath = () => "/login";

export const getGeoSurveyPath = () => "/geo/survey";
export const getRegionPage = () => "/regions";
export const getPlanningPage = () => "/planning";
export const getDevicesPage = () => "/devices";

export const getPlanningTicketPage = (ticketId) =>
  `/planning?ticketId=${ticketId}`;

export const getUserListPage = () => "/users/list";
export const getAddUserPage = () => "/users/add";
export const getEditUserPage = (userId = ":userId") => `/users/edit/${userId}`;
export const getUserRolePage = () => "/users/roles";
export const getChangePasswordPage = () => "/change-password";
export const getProfilePage = () => "/profile";
export const getAnalysisPage = () => "/analysis";
export const getAlertPage = () => "/alerts";

export const getTicketListPage = () => "/ticket/list";
export const getAddTicketPage = () => "/ticket/add";
export const getEditTicketPage = (ticketId = ":ticketId") =>
  `/ticket/${ticketId}/edit`;
export const getTicketWorkorderPage = (ticketId = ":ticketId") =>
  `/ticket/${ticketId}/workorders`;

export const getElementConfigPage = () => "/element/config";

export const getPrivacyPolicy = () => "/privacy-policy/";
export const get404 = () => "/404";

export const getFeedbackLink = () =>
  "https://drive.google.com/drive/folders/1HgHi4fqTuRau8eEKiiC6lgnlVN1FJ2YV?usp=sharing";

export const getStaticUrl = (fileName) => {
  return `/static/${fileName}`;
};

export const getLogoUrl = (fileName) => {
  return getStaticUrl("logos/" + fileName);
};

/* External server apis **/
export const apiGetVersion = () => `/api/version/`;
export const apiGetHealthCheck = () => "/api/health/check/";

// Dashboard apis
export const apiGetDashboard = () => "/api/dashboard/";
export const apiGetDashboardSurveyTicketSummery = () =>
  "/api/survey-ticket-summery/";
export const apiGetDashboardSurveyTicketSummeryExport = () =>
  "/api/survey-ticket-summery-export/";
export const apiGetCatvFavGraphConfig = (dashkey) =>
  `/api/user/dashboard/${dashkey}/config/`;
export const apiPostCatvFavGraphConfig = (dashkey) =>
  `/api/user/dashboard/${dashkey}/update/`;
export const apiGetAlertDeviceAggData = (min_count = 5, duration_days = 7) =>
  `/api/gis-alert/aggregation/device/triggercode/?min_count=${min_count}&duration_days=${duration_days}`;
export const apiPostCatvFavAlertList = (alertStatus) =>
  `/api/gis-alert/filtered/${alertStatus}/list/`;

export const apiPostLogin = () => "/api/token/";
export const apiPostLogout = () => "/api/logout/";

// area pocket apis
export const apiGetAreaPocketList = () => "/api/geo/survey/area-pocket/list/";
export const apiPostAreaPocketAdd = () => "/api/geo/survey/area-pocket/add/";
export const apiPutAreaPocketEdit = (areaPocketId) =>
  `/api/geo/survey/area-pocket/${areaPocketId}/edit/`;

// region apis

// query_type = detail | data
export const apiGetRegionList = (query_type = "detail") =>
  `/api/region/${query_type}/list/`;
export const apiPostRegionAdd = () => "/api/region/add/";
export const apiGetRegionDetails = (regionId, queryType) =>
  queryType
    ? `/api/region/${regionId}/details/?query_type=${queryType}`
    : `/api/region/${regionId}/details/`;
export const apiPutRegionEdit = (regionId) => `/api/region/${regionId}/edit/`;
export const apiRegionDelete = (regionId) => `/api/region/${regionId}/delete/`;
export const apiKmlToCoordinates = () => `/api/region/kml-to-coordinates/`;

// user & Auth apis
export const apiGetUserList = () => "/api/user/list/";
export const apiPostChangePassword = () => "/api/user/change-password/";
export const apiPostResetPassword = (userId) =>
  `/api/user/${userId}/reset/password/`;

export const apiPostProfileEdit = () => "/api/user/profile-edit/";
export const apiAddUser = () => "/api/user/add/";
export const apiUploadExcel = () => "/api/user/import-excel/";
export const apiUserExportExcel = () => "/api/user/export-excel/";
export const apiUpdateUserRegion = (userId) =>
  `/api/user/${userId}/update/regions/`;
export const apiGetUserDetails = (userId) => `/api/user/${userId}/details/`;
export const apiEditUserDetails = (userId) => `/api/user/${userId}/edit/`;
export const apiEditUserPermission = (userId) =>
  `/api/user/${userId}/update/permissions/`;
export const apiGetUserRoles = () => "/api/user/roles/";
export const apiPostUserRoleAdd = () => "/api/user/roles/add/";
export const apiPostUserRoleEdit = (roleId) =>
  `/api/user/roles/${roleId}/edit/`;
export const apiDeleteUserRole = (roleId) =>
  `/api/user/roles/${roleId}/delete/`;
export const apiGetActiveUserCount = () => "/api/user/count/";
export const apiPostNotificationSubscribe = () => "/api/user/subscribe/";

export const apiGetApplicationsList = () => "/api/applications/";

// Ticket apis
export const apiGetTicketList = () => "/api/ticket/list/";
export const apiGetTicketLayerData = () => "/api/ticket/planning/layer/";
export const apiPostTicketAdd = () => "/api/ticket/add/";
export const apiPostTicketEdit = (ticketId) => `/api/ticket/${ticketId}/edit/`;
export const apiDeleteTicket = (ticketId) => `/api/ticket/${ticketId}/delete/`;

export const apiPostTicketEditArea = (ticketId) =>
  `/api/ticket/${ticketId}/edit/area/`;
export const apiGetTicketDetails = (ticketId) =>
  `/api/ticket/${ticketId}/details/`;
export const apiGetTicketWorkorders = (ticketId) =>
  `/api/ticket/${ticketId}/workorders/`;
export const apiExportTicket = (ticketId) => `/api/ticket/${ticketId}/export/`;
export const apiImportTicket = (ticketId) => `/api/ticket/${ticketId}/import/`;
export const apiGetTicketListSummery = () => `/api/ticket/list/summery/`;
export const apiGetTicketListSummeryExport = () =>
  `/api/ticket/list/summery-export/`;

// workorder apis
export const apiPutWorkOrderEdit = (workOrderId) =>
  `/api/geo/survey/boundary/${workOrderId}/edit/`;

export const apiPutUnitEdit = (unitId = ":unit_id") =>
  `/api/geo/survey/unit/${unitId}/edit/`;

export const apiGetTicketWorkorderElements = (ticketId = ":ticketId") =>
  `/api/ticket/${ticketId}/workorders/elements/`;

export const apiPostTicketAcceptAll = (ticketId = ":ticketId") =>
  `/api/ticket/${ticketId}/workorder/verify/all/`;

export const apiPutTicketWorkorderEdit = (workOrderId) =>
  `/api/ticket/workorder/${workOrderId}/edit/`;

export const apiPutCustomerTicketWorkorderEdit = (workOrderId) =>
  `/api/ticket/customer/workorder/${workOrderId}/edit/`;

export const apiPostTicketStatusUpdate = (ticketId = ":ticketId") =>
  `/api/ticket/${ticketId}/status/update/`;

// layer config api
export const apiGetLayerConfigList = (layerKey = ":layer_key") =>
  `/api/layer/config/${layerKey}/list/`;

export const apiPostLayerConfigAdd = (layerKey = ":layer_key") =>
  `/api/layer/config/${layerKey}/add/`;

export const apiPutLayerConfigEdit = (
  layerKey = ":layer_key",
  configId = ":config_id"
) => `/api/layer/config/${layerKey}/${configId}/edit/`;

export const apiDeleteLayerConfig = (
  layerKey = ":layer_key",
  configId = ":config_id"
) => `/api/layer/config/${layerKey}/${configId}/delete/`;

export const apiGetLayerPortConfig = (
  layerKey = ":layer_key",
  configId = ":config_id"
) => `/api/layer/port/config/${layerKey}/${configId}/`;

export const apiPostPortConfigEdit = (
  layerKey = ":layer_key",
  portId = ":port_id"
) => `/api/layer/port/edit/${layerKey}/${portId}/`;

// planning apis
export const apiGetPlanningConfigs = () => "/api/planning/configs/";
export const apiGetPlanningConfigsDetails = () =>
  "/api/planning/configs/details/";
export const apiGetPlanningLayerData = () => "/api/planning/layer/";

export const apiPostValidateElementGeometry = () =>
  "/api/planning/layer/validate/geometry/";

export const apiPostAddElement = (layerKey) =>
  `/api/planning/layer/${layerKey}/add/`;

export const apiGetElementDetails = (layerKey, elementId) =>
  `/api/planning/layer/${layerKey}/${elementId}/details/`;

export const apiPutEditElement = (layerKey, elementId) =>
  `/api/planning/layer/${layerKey}/${elementId}/edit/`;

export const apiDeteleElement = (layerKey, elementId, forceDelete) => {
  let baseUrl = `/api/planning/layer/${layerKey}/${elementId}/delete/`;
  if (forceDelete) {
    baseUrl += "?force_delete=1";
  }
  return baseUrl;
};

export const apiPostPossibleConnections = () =>
  "/api/planning/possible/connections/";

export const apiGetElementConnections = (layerKey, elementId) =>
  `/api/planning/layer/${layerKey}/${elementId}/connections/`;

export const apiPostLayerUploadEdit = (
  layerKey = ":layer_key",
  configId = ":config_id"
) => `/api/planning/layer/${layerKey}/${configId}/upload-edit/`;

export const apiPostUploadDetele = (layerKey) =>
  `/api/planning/layer/${layerKey}/upload-delete/`;

// same api as edit element -> cable edit
export const apiUpdateElementConnections = (cableId) =>
  apiPutEditElement("p_cable", cableId);

export const apiGetElementAssociations = (layerKey, elementId) =>
  `/api/planning/layer/${layerKey}/${elementId}/associations/`;

export const apiPostLayerDownload = (layerKey = ":layer_key") =>
  `/api/planning/layer/${layerKey}/download/`;

export const apiPostLayerUpload = (layerKey = ":layer_key") =>
  `/api/planning/layer/${layerKey}/upload/`;

export const getGoogleAddress = (long, lat) =>
  `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${long}&key=${process.env.REACT_APP_GOOGLE_API_KEY}`;

export const apiGetElementPortDetails = (layerKey, elementId) =>
  `/api/planning/layer/${layerKey}/${elementId}/ports/`;

export const apiGetElementTransportDetails = (layerKey, elementId) =>
  `/api/planning/layer/${layerKey}/${elementId}/transport/`;

export const apiPostElementSplicingDetails = () =>
  "/api/planning/layer/splicing/details/";

export const apiPostAddPortConnection = () =>
  "/api/planning/layer/connect/ports/";

export const apiPostRemovePortConnection = () =>
  "/api/planning/layer/disconnect/ports/";

export const apiGetConnectedPort = (layerKey, portId) =>
  `/api/planning/lc/${layerKey}/${portId}/connection/`;

export const apiGenerateTraceBack = () => `/api/planning/lc/trace-back/`;
export const apiExportTraceBack = () => `/api/planning/lc/trace-back/export`;

export const apiPostLayerDataFromArea = () => `/api/planning/layers/from-area/`;
export const apiPostRoutesFromCoords = () => `/api/planning/route/from-coords/`;

// layer image and document apis
export const apiGetImageList = (layerKey, elementId) =>
  `/api/layer/image/${layerKey}/${elementId}/list/`;

export const apiDeleteImage = (layerKey, imageId) =>
  `/api/layer/image/${layerKey}/${imageId}/delete/`;

export const apiPostAddImage = (layerKey, elementId) =>
  `/api/layer/image/${layerKey}/${elementId}/upload/`;

export const apiGetDocumentList = (layerKey, elementId) =>
  `/api/layer/document/${layerKey}/${elementId}/list/`;

export const apiPostAddDocument = (layerKey, elementId) =>
  `/api/layer/document/${layerKey}/${elementId}/upload/`;

// analysis apis
export const apiPostBomReport = () => "/api/analysis/report/bom/";

export const apiPostBomPdfReport = () => "/api/analysis/report/bom/pdf";

export const apiPostlayerDataReport = () =>
  "/api/analysis/report/gis/elements/";

export const apiPostCustomerDataReport = () =>
  "/api/analysis/customer/data/report/";

export const apiPostCustomerCompletionReport = () =>
  "/api/analysis/customer/completion/report/";

export const apiPostCustomerProgressReport = () =>
  "/api/analysis/customer/progress/report/";

export const apiGetElementHistory = (layerKey, elementId) =>
  `/api/analysis/history/${layerKey}/${elementId}/`;

export const apiPostDwnloadLayerByArea = (layerKey) =>
  `/api/analysis/layer/${layerKey}/download/`;

export const apiPostAlertReport = () => "/api/analysis/alerts/report/";

// cat tv apis
export const apiGetCTGroupTagList = () => `/api/catv/interface/group/list/`;

export const apiGetCTTemplateTagList = () =>
  `/api/catv/interface/template/list/`;

export const apiGetElementGenericFieldsLastData = (layerKey, elementId) =>
  `/api/attribute/last/generic/${layerKey}/element/${elementId}/`;

export const apiGetElementInterfaceFieldsLastData = (
  layerKey,
  elementId,
  interfaceKey,
  dataType = "interface"
) =>
  `/api/attribute/last/${dataType}/${layerKey}/element/${elementId}/${interfaceKey}/`;

export const apiPostElementDataRefresh = (layerKey, elementId) =>
  `/api/attribute/refresh/${layerKey}/element/${elementId}/`;

export const apiGetAttrConfig = (attrType, layerKey, elementId) =>
  `/api/attribute/field/config/${attrType}/${layerKey}/element/${elementId}/`;

export const apiPostAttrTimeseries = () => `/api/attribute/timeseries/data/`;

export const apiGetAlertList = (alertStatus) =>
  `/api/gis-alert/${alertStatus}/list/`;

export const apiGetAlertDetails = (alertId) =>
  `/api/gis-alert/${alertId}/details/`;

export const apiGetAlertActionsList = (alertId) =>
  `/api/gis-alert/${alertId}/actions/list/`;

export const apiPostAlertAdd = () => `/api/gis-alert/actions/add/`;

export const apiGetTriggercodeList = () => `/api/gis-alert/triggercode/list/`;

export const apiPostAlertBulkUploadAction = () =>
  `/api/gis-alert/actions/bulk-upload/`;

export const apiPostCheckFeasibility = () => `/api/analysis/check/feasibility/`;
